export default "__VITE_ASSET__8c7030eb__"